import { createAction, props } from '@ngrx/store';

export const setOrganizationId = createAction(
  '[Status Summary] organization id',
  props<{ organizationId: number }>()
);

export const setDeviceId = createAction(
  '[Status Summary] device id',
  props<{ deviceId: number }>()
);
